export interface History {
    messageId:         string;
    reactionId:        string;
    provideFeedbackId: string;
    feedbackId:        string;
    reactionType:      string;
}

export const storeMessageReaction = (action: any) => {

    const messageId = action.payload.activity.activityID
    const reactionId = action.payload.activity.id
    const reactionType = action.payload.activity.reactionsAdded[0].type


    const message = getMessageById(messageId);
    if (!message) {
        createFeedbackHistory({ reactionType, messageId, reactionId, feedbackId: '', provideFeedbackId: '' })
    }
}


export const storeProvideFeedback = (action: any) => {
    const reactionId = action.payload.activity.replyToId
    const provideFeedbackId = action.payload.activity.id

    const reaction = getReactionById(reactionId)
    if (reaction) {
        const filterReaction = getFeedbackHistory().filter((history: History) => history.reactionId !== reactionId)
        filterReaction.push({ provideFeedbackId, ...reaction })
        updateFeedbackHistory(filterReaction)
    }
}

export const storeFeedback = (messageId: string, feedbackId: string) => {
    const message = getMessageById(messageId);
    if (message) {
        const filterMessage = getFeedbackHistory().filter((history: History) => history.messageId !== messageId)
        filterMessage.push({ ...message, feedbackId })
        updateFeedbackHistory(filterMessage)
    }
}


export const getFeedbackHistory = () => {
    const feedbackHistory = localStorage.getItem('feedbackHistory')
    if (!feedbackHistory) {
        localStorage.setItem('feedbackHistory', JSON.stringify([]))
        return [];
    }
    return JSON.parse(feedbackHistory)

}

const getMessageById = (messageId: string) => {
    const feedbackHistory = getFeedbackHistory();
    return feedbackHistory.find((history: History) => history.messageId === messageId);
}

const createFeedbackHistory = (history: History) => {
    const feedbackHistory = getFeedbackHistory(); 
    feedbackHistory.push(history)
    localStorage.setItem('feedbackHistory', JSON.stringify(feedbackHistory))
}

const updateFeedbackHistory = (history: History[]) => {
    localStorage.setItem('feedbackHistory', JSON.stringify(history))
}

const getReactionById = (reactionId: string) => {
    const feedbackHistory = getFeedbackHistory();
    return feedbackHistory.find((history: History) => history.reactionId === reactionId);
}